import React from "react";
import { TableCell, TableRow } from "@mui/material";
import { Create, Delete } from "@mui/icons-material";
import ButtonsAction from "../../components/Tablas/ButtonsAction";
import { butonIconTransition } from "../../../styles/stylesRows";

const RowImpresora = ({
  row,
  idx,
  eliminando,
  onEditar,
  onEliminar,
  highlightId,
  highlightType,
}) => {
  const isHighlighted = highlightId === row.imp_id;
  let bg = idx % 2 === 0 ? "action.hover" : "inherit";
  if (isHighlighted && highlightType === "new")
    bg = "rgba(76, 175, 80, 0.15)";
  else if (isHighlighted && highlightType === "update")
    bg = "rgba(33, 150, 243, 0.12)";

  return (
    <TableRow
      hover={!isHighlighted}
      sx={{
        height: "1.75rem",
        backgroundColor: bg,
        transition: "background-color 0.5s",
        "& td": {
          fontSize: "0.7rem",
          p: "1px 4px",
          borderBottom: "0.5px solid #ddd",
        },
      }}
    >
      <ButtonsAction
        row={row}
        botones={[
          {
            tooltip: "Editar Registro",
            texto: "",
            funcion: onEditar,
            disabled: eliminando,
            Icon: Create,
            color: "secondary",
            id: 2,
            ocultar: false,
            tipo: "icono",
            variante: "contained",
            size: "small",
            sx: butonIconTransition,
          },
          {
            tooltip: "Eliminar Registro",
            texto: "",
            funcion: onEliminar,
            disabled: eliminando,
            Icon: Delete,
            color: "error",
            id: 3,
            ocultar: false,
            tipo: "icono",
            variante: "contained",
            size: "small",
            sx: butonIconTransition,
          },
        ]}
      />
      <TableCell align="left">{row.imp_nombre}</TableCell>
      <TableCell align="left">{row.imp_ip || "—"}</TableCell>
    </TableRow>
  );
};

export default React.memo(RowImpresora);
